import m from 'mithril'
import stream from 'mithril/stream'
import {
    Dialog,
    TextBox,
    Button,
    TextArea,
    Paging
} from 'components'
import * as Components from 'components'
import {
    User,
} from "app/models"
import moment from 'moment'
import ArticleDetailComponent from './articleDetail'




class ArticleDialog {
    constructor(vnode) {
        this.records = [];
        User.getArticleRecord()
    }
    close(event, value) {
        setTimeout(() => {
            Dialog.close(false)
            m.redraw()
        }, 200)
    }

    view({
        attrs
    }) {
        return m('.modal-dialog.modal-dialog-centered.modal-dialog-scrollable', [
            m('.modal-content', [
                m('.modal-header', {
                    style: {
                        backgroundColor: "#B6B6B6"
                    }
                }, [
                    m('h5.modal-title', [
                        m('span', "文章紀錄")
                    ]),
                    m('button[type="button"].close', {
                        onclick: this.close.bind(this)
                    }, [
                        m('span', m.trust('&times;'))
                    ])
                ]),
                m(".modal-body.p-0", [
                    m(".row.m-0.w-100.pt-2", [
                        m(".col-12.pb-1.d-flex.justify-content-end.align-items-center", [
                            m("i.fa-regular.fa-hand-point-down", { style: { color: "#3027A1", fontSize: "0.8rem" } }),
                            m("span.font-weight-bold.pl-2", { style: { color: "#3027A1", fontSize: "0.8rem" } }, "點擊即可查看紀錄"),
                        ]),
                        User.articleRecord.map((_record, _index) => {
                            return [
                                m(".col-12.pb-1", [
                                    m(".row.m-0.w-100.py-1.d-flex.justify-content-center", {
                                        style: {
                                            border: "1px solid #000000",
                                            borderRadius: "5px",
                                        },
                                        onclick: (e) => {
                                            e.preventDefault()
                                            Dialog.show(ArticleDetailComponent, {
                                                attrs: {
                                                    model: _record,
                                                    onClose: (e) => {
                                                        this.close()
                                                        attrs.onFix()
                                                        m.redraw()
                                                    }
                                                },
                                            })
                                        }
                                    }, [
                                        m(".col-1.d-flex.justify-content-start.align-items-center.pb-2", [
                                            m("span.font-weight-bold", { style: { fontSize: "1rem" } }, _index + 1)
                                        ]),
                                        m(".col-7.d-flex.justify-content-start.align-items-center.pb-2", [
                                            // (_record.articles[0].hasOwnProperty("message")) ? "" :

                                            //     m("div.img-fluid", {
                                            //         style: {
                                            //             height: "120px",
                                            //             width: "120px",
                                            //             maxHeight: "120px",
                                            //             maxWidth: "120px",
                                            //             backgroundImage: `url("${_record.articles[0].url}")`,
                                            //             backgroundRepeat: "no-repeat",
                                            //             backgroundPosition: "center",
                                            //             backgroundSize: "cover",
                                            //             border: "1px solid #EFEFEF",
                                            //             borderRadius: "5px",
                                            //             cursor: "pointer",
                                            //         },
                                            //     }),
                                            m("span.font-weight-bold.pl-2", { style: { fontSize: "1rem" } }, _record.model_name),

                                            // m("span.font-weight-bold", { style: { fontSize: "1rem" } }, _record.model_name)
                                        ]),
                                        m(".col-4.d-flex.justify-content-end.align-items-center.pb-2", [
                                            m("span", { style: { color: "grey", fontSize: "0.8rem" } }, moment(_record.created_at).format("Y-MM-DD hh:mm"))
                                        ]),
                                        (_record.articles[0].hasOwnProperty("message")) ?
                                            m(".col-12.d-flex.align-items-center", [
                                                m("p", {
                                                    style: {
                                                        color: "grey", fontSize: "0.8rem", fontStyle: "italic", margin: 0, overflow: "hidden",
                                                        "text-overflow": "ellipsis", "white-space": "nowrap",
                                                    }
                                                }, _record.articles[0].message.content.split('\n').slice(0, 2).join('\n'))
                                            ]) : m(".col-11.d-flex.align-items-center", {
                                                style: {
                                                    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url("${_record.articles[0].url}")`,
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center",
                                                    backgroundSize: "cover",
                                                    cursor: "pointer",
                                                    minHeight: "80px",
                                                },
                                            }, [

                                            ])
                                    ]),
                                ])
                            ];
                        })
                    ]),
                    m('.row.no-gutters.px-5', [
                        m('.col-12.pt-3', [
                            m('.d-flex.flex-sm-row.flex-column.justify-content-md-between', [
                                m(Paging.Pagination, {
                                    pageNo: User.paging.pageNo,
                                    pageCount: User.paging.pageCount,
                                    pageUrl: User.getArticleRecord.bind(this)
                                }),
                                // m(Paging.PageItemCount, {
                                //     pageNo: User.paging.pageNo,
                                //     pageSize: User.paging.pageSize,
                                //     total: User.paging.totalRecordCount
                                // })
                            ])
                        ])
                    ]),
                ]),
                m('.modal-footer', [
                    m(".text-center.py-1.px-3", {
                        style: {
                            color: "#B6B6B6",
                            borderRadius: "25px",
                            border: "2px solid #B6B6B6",
                            fontWeight: 700,
                            fontSize: "1.25rem"
                        },
                        onclick: this.close.bind(this)
                    }, '關閉')
                ]),
            ])
        ])
    }
}

export default ArticleDialog